export const PARAMS = {
  NODE_ID: "NodeId",
  SPORT_HANDLE: "SportHandle",
  NAME: "Name",
  LEAGUE_NAME: "LeagueName",
  START_DATE: "StartDate",
  SPORT_NAME: "SportName",
  TEAM: "team",
};

export const SPORTS_NAVIGATION_SERVICE_ERROR_CODES = {
  GENERIC_POLLING_ERROR: "GENERIC_POLLING_ERROR",
  BETSENSE_POLLING_ERROR: "BETSENSE_POLLING_ERROR",
  GENERIC_ERROR: "GENERIC_ERROR",
  EMPTY_DATA_ERROR: "EMPTY_DATA_ERROR",
  EMPTY_DATA_WARNING_ERROR: "EMPTY_DATA_WARNING_ERROR",
  CUSTOM_TYPE: "CUSTOM_TYPE",
};

export const SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION = {
  LOCATION_0: {
    DESCRIPTION: "Error in video-player",
    ID: 0,
  },
  LOCATION_1: {
    DESCRIPTION: "Error in Event Main Categories",
    ID: 1,
  },
  LOCATION_2: {
    DESCRIPTION: "Error in Event Markets Categories",
    ID: 2,
  },
  LOCATION_3: {
    DESCRIPTION: "Error in Event Special Markets Categories",
    ID: 3,
  },
  LOCATION_4: {
    DESCRIPTION: "Error in Event Early Markets Categories",
    ID: 4,
  },
  LOCATION_5: {
    DESCRIPTION: "Error in Event polling",
    ID: 5,
  },
  LOCATION_6: {
    DESCRIPTION: "Error in Home polling",
    ID: 6,
  },
  LOCATION_7: {
    DESCRIPTION: "Empty categories in Init Live response",
    ID: 7,
  },
  LOCATION_8: {
    DESCRIPTION: "Error in Init Live Effect",
    ID: 8,
  },
  LOCATION_9: {
    DESCRIPTION: "Error in setSelectedSportsNav Effect",
    ID: 9,
  },
  LOCATION_10: {
    DESCRIPTION: "Error in Live Polling",
    ID: 10,
  },
  LOCATION_11: {
    DESCRIPTION: "Error in live market constructor",
    ID: 11,
  },
  LOCATION_12: {
    DESCRIPTION: "Error in Market Live Polling",
    ID: 12,
  },
  LOCATION_13: {
    DESCRIPTION: "Error in Live Market Betsense Polling",
    ID: 13,
  },
  LOCATION_14: {
    DESCRIPTION: "Error in Market Categories",
    ID: 14,
  },
  LOCATION_15: {
    DESCRIPTION: "Error in Market Betsense Polling",
    ID: 15,
  },
  LOCATION_16: {
    DESCRIPTION: "Error in getTicketsByDate func",
    ID: 16,
  },
  LOCATION_17: {
    DESCRIPTION: "Error in getCashoutByTicket func",
    ID: 17,
  },
  LOCATION_18: {
    DESCRIPTION: "Error getting races information",
    ID: 18,
  },
  LOCATION_19: {
    DESCRIPTION: "Error in init Race Market. Empty next races",
    ID: 19,
  },
  LOCATION_20: {
    DESCRIPTION: "Error getting next races",
    ID: 20,
  },
  LOCATION_21: {
    DESCRIPTION: "Error in Race Market polling. Empty participants.",
    ID: 21,
  },
  LOCATION_22: {
    DESCRIPTION: "Error in Race Market polling",
    ID: 22,
  },
  LOCATION_23: {
    DESCRIPTION: "Error getting Sport Countries",
    ID: 23,
  },
  LOCATION_24: {
    DESCRIPTION: "Error in Today",
    ID: 24,
  },
  LOCATION_25: {
    DESCRIPTION: "Error in Today Polling",
    ID: 25,
  },
};

export const SPORTS_NAVIGATION_ERROR_TEXTS = {
  TEXT_0: "No hay eventos disponibles en este momento.",
  TEXT_1: "No hay eventos en vivo disponibles en este momento.",
  TEXT_2: "No hay mercados disponibles en este momento.",
  TEXT_3: "No hay carreras disponibles en este momento.",
  TEXT_4: "No hay próximas carreras disponibles en este momento.",
};
